import EF from 'ef/ef';
import View from 'views/base/view';
import NavigationService from 'services/course-handler-services/navigation-service';
import { SessionStorageService } from 'services/data-handler-services/web-storage-service';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import i18next from 'i18next';
import LocaleService from 'services/loader-handler-services/locale-service';
import ActionbarTemplate from 'views/actionbar/templates/actionbar';
import Chaplin from 'chaplin';
import _ from 'lodash';
import $ from 'jquery';

const ActionbarView = View.extend({
  template: ActionbarTemplate,
  autoRender: true,
  className: 'row',
  listen: {
    'page:state:completed mediator': 'completed',
    'media:status:changed mediator': 'mediaStateChanged',
    'media:play mediator': 'mediaPlay',
    'media:narration mediator': 'narrationChanged',
    'media:mute:change mediator': 'muteChange',
    'button:disabled mediator': 'disableButton',
    'button:enabled mediator': 'enableButton',
  },
  setElemId: function (event) {
    if (event) {
      this.focusedElemId = $(event.target).attr('id');
    }
  },
  initialize: function () {
    //TODO: figure out what to do with page templates that don't use some of the buttons
    this.model.set('narration', EF.enrollment.getData('narration'));
    this.model.set('mute', EF.enrollment.getData('muted') === 'on');
    this.model.set('media_status_text', LocaleService.t('mediaAccessibility.none'));
    if (CourseSettingsService.get('transcript')) {
      this.model.set('transcript', true);
    }
    this.on('addedToDOM', this.addEventDelegates);

    const queryParams = SessionStorageService.getItem('queryParams');
    if (queryParams && queryParams.next && queryParams.next === 'disabled') {
      this.model.set('nextDisabled', true);
    }
    if (!EF.module.currentActivity.currentPage.get('completed') && !EF.enrollment.get('demoMode')) {
      this.model.set('nextDisabled', true);
    }
    const actionBarConfig = CourseSettingsService.get('actionBar');
    if (actionBarConfig !== undefined && actionBarConfig.localeSwitcher !== undefined) {
      this.model.set('localeSwitcher', Boolean(actionBarConfig.localeSwitcher));
      this.model.set(
        'languages',
        CourseSettingsService.get('supported_languages').filter(l => l !== 'cimode')
      );
      this.model.set('language', i18next.language);
    }
    View.prototype.initialize.apply(this, arguments);
  },
  addEventDelegates: function () {
    // focus selected actionbar button after render
    this.render = _.wrap(this.render, function (render) {
      render();
      if (this.focusedElemId) {
        this.$(`#${this.focusedElemId}`).focus();
      }
    });

    this.subscribeEvent('action:unload', function () {
      if (this.model) {
        this.model.set('nextDisabled', false);
        this.render();
      }
    });

    this.delegate('click', '#play_button', function (e) {
      this.setElemId(e);
      if (this.model.get('media_status') === 'completed') {
        Chaplin.mediator.publish(`media:play:${this.model.get('mediaId')}`);
      } else {
        Chaplin.mediator.publish(`action:${this.model.get('playing') ? 'pause' : 'resume'}`);
      }
    });

    this.delegate('click', '#mute_button', function (e) {
      this.setElemId(e);
      const currentState = $(e.target).attr('data-mute-state');
      Chaplin.mediator.publish(`action:${currentState === 'on' ? 'unmute' : 'mute'}`);
    });

    this.delegate('click', '#narration_toggle', function (e) {
      this.setElemId(e);
      const narration = !this.model.get('narration');
      EF.enrollment.setData('narration', narration);
      this.model.set('narration', narration);
      this.model.set('showNarration', narration && this.model.get('narrationText'));
      Chaplin.mediator.publish('media:captions:change');
      this.render();
    });

    this.delegate('change', '#locale-switcher', function (e) {
      if (this.model.has('languages') && this.model.get('languages').includes(e.target.value)) {
        i18next.changeLanguage(e.target.value);
        LocaleService.initialize().done(function () {
          NavigationService.reload();
        });
      }
    });

    this.delegate('click', '[data-navigate]', function (e) {
      e.preventDefault();
      const navigateTo = $(e.target).attr('data-navigate');
      if (this.model.get('nextDisabled') && navigateTo === 'forward') {
        return;
      }
      Chaplin.mediator.publish('page:navigate', navigateTo);
    });

    this.delegate('click', '[data-close]', function (e) {
      e.preventDefault();
      Chaplin.mediator.publish('feedback:all:close');
    });
  },
  mediaPlay: function (mediaId, isBackground) {
    if (!isBackground) {
      this.model.set('mediaId', mediaId);
    }
  },
  disableButton: function (buttonId) {
    this.model.set(`disable_${buttonId}`, true);
  },
  enableButton: function (buttonId) {
    this.model.set(`disable_${buttonId}`, false);
  },
  mediaStateChanged: function (status, mediaId) {
    if (this.model.get('mediaId') === mediaId) {
      this.model.set('media_status', status);
      if (status === 'playing') {
        this.model.set('playing', true);
      } else {
        this.model.set('playing', false);
      }
      this.model.set('media_status_text', LocaleService.t(`mediaAccessibility.${this.model.get('media_status')}`));
      this.render();
    }
  },
  completed: function () {
    this.model.set('nextDisabled', false);
    this.render();
  },
  narrationChanged: function (narrationText) {
    this.model.set('narrationText', narrationText);
    this.model.set('showNarration', narrationText && this.model.get('narration'));
    this.render();
  },
  muteChange: function (muted) {
    EF.enrollment.setData('muted', muted);
    this.model.set('mute', muted === 'on');
    this.render();
  },
});

export default ActionbarView;
